import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
  Typography,
  Tabs,
  Tab,
  Paper,
  Alert,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { getUsersWithAccess, toggleAdministrationAudit } from "../store/ducks/duckHelp";
import { useUser } from "../auth/UserProvider";

import { BorderLinearProgress } from "./LoadingComponent";

const TabStyled = withStyles(() => ({
  root: {
    minWidth: 300,
    width: 300,
  },
}))(Tab);

const HelpModal = () => {
  const dispatch = useDispatch();
  const { isAdmin, isOwner } = useUser();
  const isAdminOrOwner = isAdmin || isOwner;

  const [tab, setTab] = useState(0);

  const {
    data,
    isOpen: open,
    isLoading,
    layoutIsPublic: isPublic,
  } = useSelector((state) => state.help);
  const { id } = useParams();
  const handleClose = () => dispatch(toggleAdministrationAudit());

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    if (isAdminOrOwner && open) {
      dispatch(getUsersWithAccess(id));
    }
  }, [dispatch, id, isAdminOrOwner, open]);

  return (
    <>
      {isAdminOrOwner ? (
        <Dialog
          fullWidth
          aria-labelledby="form-dialog-title"
          maxWidth={isPublic ? "sm" : "md"}
          open={open}
          onClose={handleClose}
        >
          {isLoading && <BorderLinearProgress />}
          <DialogTitle id="form-dialog-title">Groups</DialogTitle>
          <DialogContent style={{ overflow: "y", backgroundColor: "#f5f5f5" }}>
            <Grid container alignItems="center" direction="row" justify="center" spacing={2}>
              <Grid item xs={12}>
                <Paper>
                  <Tabs
                    aria-label="TabsGroups"
                    indicatorColor="primary"
                    textColor="primary"
                    value={tab}
                    variant="scrollable"
                    onChange={handleChange}
                  >
                    {data &&
                      data.map(({ group }, i) => (
                        <TabStyled key={`Tab-${group}`} label={group} value={i} />
                      ))}
                  </Tabs>
                </Paper>
                {isPublic && (
                  <Alert key="Alert-IsPublic" severity="success">
                    This Layout is Public
                  </Alert>
                )}

                {data &&
                  data.map(({ group, users }, i) => (
                    <Typography
                      key={`div-container-tabPanel-${group}`}
                      aria-labelledby={`simple-tab-${group}`}
                      component="div"
                      hidden={tab !== i}
                      role="tabpanel"
                    >
                      {users &&
                        users.map((u, i) => {
                          let name = `${u.firstName} ${u.lastName}`;
                          const { networkUser, group, emailAddress } = u;
                          const tooltip = (
                            <ul>
                              <li>Network User: {networkUser}</li>
                              <li>Group: {group}</li>
                              <li>Email: {emailAddress}</li>
                            </ul>
                          );

                          if (tooltip) {
                            return (
                              <Tooltip
                                key={`Tooltip-group-${group}-User-${name}-${i}`}
                                title={tooltip}
                              >
                                <Chip
                                  key={`Chip-group-${group}-User-${i}`}
                                  color="default"
                                  label={name}
                                  style={{ margin: 5 }}
                                />
                              </Tooltip>
                            );
                          } else {
                            return (
                              <Chip
                                key={`Chip-group-${group}-User-${i}`}
                                color="default"
                                label={name}
                                style={{ margin: 5 }}
                              />
                            );
                          }
                        })}
                    </Typography>
                  ))}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="primary" variant="contained" onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default HelpModal;
